import ModuleMate from "./moduleMate";
import ModuleWorldview from "./moduleWorldview";
import { Mate, ModuleEntityType, Worldview } from "@/types/entity";
import { MateModule, ModuleQuestion } from "@/types/entity";
import ModuleBaseImpl from "./moduleBaseImpl";

export const createModule = (
  entityType: ModuleEntityType,
  entity: Mate | Worldview,
  mateModuleList: MateModule[],
  moduleQuestionMap: Record<number, ModuleQuestion[]>
): ModuleBaseImpl => {
  if (entityType === "mate") {
    return new ModuleMate(
      entity,
      entityType,
      mateModuleList,
      moduleQuestionMap
    );
  } else {
    return new ModuleWorldview(
      entity,
      entityType,
      mateModuleList,
      moduleQuestionMap
    );
  }
};
